<template>
    <div>
      <div class="modal hide fade" id="modalGetProduct" tabindex="-1" role="dialog" aria-labelledby="modalGetProduct" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">Product Lists</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="table-responsive">
                    <div class="form-inline ml-auto">
                      <!-- <span>Warehouse:</span>
                      <select v-model="wh_no" class="btn btn-sm btn-outline-primary mr-1">
                        <option value="">---</option>
                        <option v-for="w in warehouseList" :key="w.warehouse_no" :value="w.warehouse_no">{{ w.name }}</option>
                      </select> -->
                      <span class="mr-1">Search By:</span>
                      <select v-model="filterSearchBy" class="btn btn-sm btn-outline-primary mr-1">
                        <option value="product_no">Product No</option>
                        <option value="product_name">Name</option>
                      </select>
                      <select v-model="categoryProduct" class="btn btn-sm btn-outline-primary mr-1">
                        <option value="">--All--</option>
                        <option v-for="c in productCategoryList" :key="c.id" :value="c.id">{{ c.name }}</option>
                      </select>
                      <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refresh">
                        <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                      </button>
                      <div class="button-group">
                        rows:
                        <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                          <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                        </select>
                        <span class="mr-1">
                          Total rows: <b>{{ rowsTotal }}</b>
                        </span>
                      </div>
                      <div class="form-group mx-sm-3 mb-2">
                          <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                      </div>
                      <span class="mr-1">
                        page:
                        <select v-model="currentPage">
                          <option v-for="p in pageLength" :key="p" :value="p">{{ p }}</option>
                        </select>
                        / {{ pageLength }}
                      </span>
                      <nav aria-label="Page navigation example" class="pull-right">
                          <ul class="pagination">
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                                  </a>
                              </li>
                              <li class="page-item">
                                  <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                                  </a>
                              </li>
                          </ul>
                      </nav>
                    </div>
                    <table class="table table-item mb-0 table-sm table-hover">
                        <thead>
                            <tr>
                                <th  v-for="t in title" v-bind:key="t.prop" @click="sortTable(t.prop)">
                                    {{ t.name }}
                                    <div class="float-right fa" v-if="t.prop == sortColumn" v-bind:class="ascending ? 'fa-arrow-up' : 'fa-arrow-down'"></div>
                                </th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                          <tr v-if="filterData.length < 1">
                            <td colspan="9" style="text-align: center;">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </td>
                          </tr>
                          <tr v-for="u in filterData" v-bind:key="u.id" style="cursor: pointer">
                            <td @click="select(u.id)" data-dismiss="modal"><b>{{ u.product_no }}</b></td>
                            <td @click="select(u.id)" data-dismiss="modal">{{ u.product_name }}</td>
                            <td @click="select(u.id)" data-dismiss="modal">
                              <span v-if="u.cost_uom_id === null"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>
                              <span v-else>{{ u.cost_qty }}</span>
                            </td>
                            <td @click="select(u.id)" data-dismiss="modal">
                              <span v-if="u.cost_uom_id === null"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span>
                              <span v-else>{{ u.cost_uom_id }}</span>
                            </td>
                            <td>
                              <button class="btn btn-sm btn-success" @click="getCogs(u.product_no)">Get Saldo</button>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- <pre>{{ priceid }}</pre> -->
              <!-- <pre>{{ branch }}</pre> -->
              <!-- <pre>{{ date }}</pre> -->
              <!-- <pre>{{ productListAll }}</pre> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
// import axios from 'axios'
import Axios from 'axios'
import { mapState } from 'vuex'
import { productUrl, getHeader } from '../../config'

export default {
  name: 'SalesProductModal',
  props: ['sales', 'date', 'status'],
  data () {
    return {
      stopCall: false,
      filterSearchBy: 'product_name',
      load: false,
      wh_no: 'WH0001',
      categoryProduct: '',
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Product No',
        prop: 'product_no'
      }, {
        name: 'Name',
        prop: 'product_name'
      }, {
        name: 'Qty',
        prop: 'cost_qty'
      }, {
        name: 'Uom',
        prop: 'uom_id'
      }],
      selectAll: false,
      selected: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      dataRaw: []
    }
  },
  computed: {
    ...mapState({
      priceListGroup: state => state.priceLists.priceListGroup,
      productCategoryList: state => state.products.productCategoryList,
      warehouseList: state => state.warehouses.warehouseList,
      // productListAll: state => state.products.productTotalList,
      productListAll: state => state.products.productListSelect,
      rowsTable: state => state.data.rowsTable
    }),
    getPrice: function () {
      var array = this.productListAll
      var pl = null
      for (let i = 0; i < array.length; i++) {
        pl = array[i]
      }
      return pl
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.currentPage = 1
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (this.filterSearchBy === 'product_name') {
              if (d.product_name.toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                return d
              }
            } else if (this.filterSearchBy === 'product_no') {
              if (d.product_no.toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                return d
              }
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async getCogs (productNo) {
      const obj = {
        product_no: productNo,
        date: this.date
      }
      console.log(obj)
      const product = this.dataRaw.find(d => d.product_no === productNo)
      await Axios.post(productUrl + '/cost/get-saldo-qty', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          product.cost_qty = response.data.data.saldo_qty
          product.cost_uom_id = response.data.data.uom_id
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
    },
    async refresh () {
      // this.$store.commit('SET_PRODUCT_TOTAL_LIST', [])
      // const payload = {
      //   date: new Date().toISOString()
      // }
      // this.$store.dispatch('getProductWithTotal', payload)

      // await this.$store.commit('SET_PRODUCT_LIST_SELECT', [])
      // await this.$store.dispatch('getProductListSelect')
      this.stopCall = false
      await Axios.get(productUrl + '/list-select', { headers: getHeader() })
        .then(response => {
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
        })
      for (let i = 0; i < this.dataRaw.length; i++) {
        if (this.stopCall === false) {
          await this.getCogs(this.dataRaw[i].product_no)
        } else {
          break
        }
      }
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select (id) {
      this.stopCall = true
      // const product = this.productListAll.find(d => d.id === id)
      const product = this.dataRaw.find(d => d.id === id)
      product.warehouse_no = this.wh_no
      this.$emit('selectProduct', product)
      // if (product.cost_qty > 0) {
      //   product.warehouse_no = this.wh_no
      //   this.$emit('selectProduct', product)
      // } else {
      //   if (this.status === 'order' || this.status === 'workshop') {
      //     product.warehouse_no = this.wh_no
      //     this.$emit('selectProduct', product)
      //   } else {
      //     this.$swal('Error', 'Stok kosong, silahkan periksa Product Summary terlebih dahulu', 'error')
      //   }
      // }
    }
  },
  mounted () {
    // this.loadList()
  }
}
</script>
